import type { ReactNode } from 'react';

export const symbol_game_trigger_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M348-385v-209.64q0-11.36-7-18.36t-18-7q-11 0-18 7t-7 18v226q0 12.75 8.63 21.37Q315.25-339 328-339h120q10.12 0 16.56-6.42 6.44-6.41 6.44-16.5 0-10.08-6.44-16.58-6.44-6.5-16.56-6.5H348Zm219-189v209.64q0 11.36 7 18.36t18 7q11 0 18-7t7-18.36V-574h61q10.12 0 16.56-6.42 6.44-6.41 6.44-16.5 0-10.08-6.44-16.58-6.44-6.5-16.56-6.5H505q-10.12 0-16.56 6.42-6.44 6.41-6.44 16.5 0 10.08 6.44 16.58 6.44 6.5 16.56 6.5h62ZM80-220v-426q0-63.53 44.5-108.76Q169-800 233-800h494q64 0 108.5 45.24Q880-709.53 880-646v426q0 24.75-17.62 42.37Q844.75-160 820-160H140q-24.75 0-42.37-17.63Q80-195.25 80-220Zm60 0h680v-426q0-38.78-27-66.39T727-740H233q-39 0-66 27.61T140-646v426Zm0 0h680-680Z"
		/>
	</svg>
);
